import React from "react";
import Slider from "react-slick";
import Herosection from "./HeroSection";
import Card from "./Card";
import Project from "./Project";
import Choosus from "./Choosus";
import Client from "./Client";
import Partner from "./Partener";
import Footer from "./Footer";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// 👉 First Row Data

const firstRowCards = [
    {
    image: "Beachwalk.png",
    heading: "Beach Walk Residence 4",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Beach Walk 4.pdf",
    status: "Recently Launched",
  },
  {
    image: "WeybridgeGardens5.png",
    heading: "Weybridge Gardens 5",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Weybridge Gardens 5.pdf",
    status: "Recently Launched",
  },
   {
    image: "Ag Ark.jpg",
    heading: "Ag Ark",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Ag Ark.pdf",
    status: "Recently Launched",
  },
  {
    image: "Forestcity.webp",
    heading: "Forest City",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Forest City 2.pdf",
    status: "Recently Launched",
  },
  {
    image: "azure.png",
    heading: "Azura Residences by IGO",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Azura Residences by IGO.pdf",
    status: "For sale",
  },
  {
    image: "bayz.png",
    heading: "Bayz 102",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Bayz 102.pdf",
    status: "For sale",
  },
  {
    image: "beachresidence.png",
    heading: "Beach Residences at Siniya Island",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Beach Residences at Siniya Island.pdf",
    status: "For sale",
    
  },
    {
    image: "baynbyora.png",
    heading: "Bayn by Ora",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Bayn by Ora.pdf",
    status: "Recently Launched",
  },
];

// 👉 Second Row Data
const secondRowCards = [
  {
    image: "marquisvista.jpg",
    heading: "  Marquis Vista",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Marquis Vista.pdf",
    status: "Recently Launched",
  },
  {
    image: "Reef 1000.png",
    heading: " Reef 1000",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "  Reef 1000.pdf",
    status: "Recently Launched",
  },
  {
    image: "Verdanaempire.png",
    heading: "Verdana Empire",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Verdana Empire.pdf",
    status: "Recently Launched",
  },
  {
     image:"luzoraresidence.png",
    heading : "Luzora Residences",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "  Luzora Residence.pdf",
    status: "Recently Launched",
  
  },

  {
    image: "Reportage Hills.png",
    heading: "Reportage Hills",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Reportage Hills.pdf",
    status: "Recently Launched",
  },

  {
    image: "blisshomes.png",
    heading: "Bliss Homes",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Bliss Homes.pdf",
    status: "For sale",
  },
  {
    image: "burz.png",
    heading: "Burj Azizi",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Burj Azizi.pdf",
    status: "For sale",
  },
  {
    image: "layla.png",
    heading: "Laya Heights",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Laya Heights.pdf",
    status: "For sale",
  },
  {
    image: "peacelagoons.png",
    heading: "Peace Lagoons",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Peace Lagoons.pdf",
    status: "Recently Launched",
  },
];

const Home = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="xsm:overflow-hidden xsm:-mt-10">
      <Herosection />

      <div className="flex flex-col items-center p-10 xsm:p-4">
        <p className="text-[#9A7B4F]">Find rental properties anywhere</p>
        <h1 className="text-3xl xsm:text-base font-bold mb-6">
          Discover Popular Property
        </h1>

        {/* ⭐ First Slider */}
        <div className="w-full px-4 mb-10">
          <Slider {...settings}>
            {firstRowCards.map((item, index) => (
              <div key={index} className="p-2">
                <Card
                  heading={item.heading}
                  para={item.para}
                  price={item.price}
                  image={item.image}
                  url={item.url}
                  status={item.status} 
                />
              </div>
            ))}
          </Slider>
        </div>

        {/* ⭐ Second Slider */}
        <div className="w-full px-4">
          <Slider {...settings}>
            {secondRowCards.map((item, index) => (
              <div key={index} className="p-2">
                <Card
                  heading={item.heading}
                  para={item.para}
                  price={item.price}
                  image={item.image}
                  url={item.url}
                  status={item.status} 
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Other Sections */}
      <Project />
      <Choosus />
      <Client />
      <Partner />
      <Footer />
    </div>
  );
};

export default Home;
